<template>
  <div class="order-submission">
    <!-- 彩条图片 -->
    <!-- <div class="line">
      <img src="@assets/images/line.jpg" />
    </div> -->

    <!-- 标题 -->
    <div class="title_nav">
      <div @click="$router.go(-1)">
        <Icon name="arrow-left" style="margin-top:0.1rem" />
      </div>
      <div style="padding-top:0.05rem" class="nav_address">提交订单</div>
    </div>
    <!-- 标题 -->

    <!-- <div class="address acea-row row-between-wrapper" @click="addressTap">
      <div class="addressCon" v-if="addressInfo.real_name">
        <div class="name">
          {{ addressInfo.real_name }}
          <span class="phone">{{ addressInfo.phone }}</span>
        </div>
        <div>
          <span class="default font-color-red" v-if="addressInfo.is_default"
            >[默认]</span
          >
          {{ addressInfo.province }}{{ addressInfo.city
          }}{{ addressInfo.district }}{{ addressInfo.detail }}
        </div>
      </div>
      <div class="addressCon" v-else>
        <div class="setaddress">设置收货地址</div>
      </div>
      <div class="iconfont icon-jiantou"></div>
    </div> -->
    <!-- 非实物兑换界面 -->
    <div v-if="chargeAccountList .length !=0">
      <div class="refundlists" v-if="chargeAccountList.goodsType == 2">
        <div class="item" v-if="chargeAccountList.useType == 'mobile'">
          <div class="name">待充值手机号：</div>
          <input type="text" placeholder="请输入手机号" v-model="xuankuaphone" required />
          <div class="prompttext">正在为账号{{ xuankuaphone }}充值，请核对账号!</div>
        </div>
        <div class="item" v-if="chargeAccountList.useType == 'wechat'">
          <div class="name">待充值微信号：</div>
          <input type="text" placeholder="请输入微信号" v-model="xuankuaphone" required />
          <div class="prompttext">正在为账号{{ xuankuaphone }}充值，请核对账号!</div>
        </div>
        <div class="item" v-if="chargeAccountList.useType == 'mobile,QQ'">
          <div class="name">待充值QQ号或手机号：</div>
          <input type="text" placeholder="请输入QQ号或手机号" v-model="xuankuaphone" required />
          <div class="prompttext">正在为账号{{ xuankuaphone }}充值，请核对账号!</div>
        </div>
      </div>
    </div>
    <!-- 用户信息 -->
    <div class="refundlist" v-if="chargeAccountList.length==0">
      <div>
        <div class="userText">
          <div class="userDefault" v-if="addressInfo.is_default">默认</div>
          <div> {{ addressInfo.real_name }}<span>{{ addressInfo.phone }}</span></div>
        </div>
        <div class="userAddress">
          <div v-if="!addressInfo.real_name">
            <Icon name="location-o" /><span>设置收货地址</span>
          </div>
          <span>{{ addressInfo.province }}{{ addressInfo.city
          }}{{ addressInfo.district }}{{ addressInfo.detail }}</span>
        </div>
      </div>
      <div class="routerArrow" @click="addressTap">
        <Icon name="arrow" />
      </div>
    </div>
    
    <div class="detalis_box">
      <div class="quantity">共{{ orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length }}件商品</div>
      <div class="quantit" v-for="cart in orderGroupInfo.cartInfo" :key="cart.id">
        <div>
          <img :src="cart.productInfo.image" alt="" />
        </div>
        <div class="quantiy">
          <div calss="size">{{ cart.productInfo.store_name }}</div>
          <div class="quan">
            <div class="tity"> 
              <div><img src="@/assets/images/icon-money.png" alt=""></div>
        <div>
          {{
              cart.productInfo.attrInfo
              ? cart.productInfo.attrInfo.price
              : cart.productInfo.price
            }}
        </div>
            </div>
            <div style="margin-right:0.2rem">x{{ cart.cart_num }}</div>
          </div>
        </div>
      </div>
      <div class="Summary">共{{ orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length }}件商品 总金额：{{
        orderPrice.total_price }}</div>
    </div>

    <div class="detalis_box">
      <div class="Expressfreight">
        <div>快递运费</div>
        {{
            orderPrice.pay_postage > 0
              ? orderPrice.pay_postage
              : "免运费"
          }}
      </div>
    </div>
    <!-- 旧商品信息 -->
    <!-- <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods> -->
    <div class="wrapper">
      <div class="item acea-row row-between-wrapper" @click="couponTap" v-show="false" v-if="deduction === false">
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <!-- <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>-->

      <!-- 快递费用 -->
      <!-- <div class="item acea-row row-between-wrapper">
        <div>快递费用</div>
        <div class="discount">

          {{
            orderPrice.pay_postage > 0
              ? orderPrice.pay_postage
              : "免运费"
          }}

        </div>
      </div> -->
      <div class="item" v-if="false">
        <div>备注信息</div>
        <textarea placeholder="请添加备注（150字以内）" v-model="mark"></textarea>
      </div>
    </div>
    <!-- 支付方式 -->
    <!-- <div class="wrapper" v-if="couponsList.length >= 1">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin"
          >

            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
            v-if="orderPrice.pay_price <= userInfo.now_money"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              点券支付
            </div>
            <div class="tip">可用点券：{{ userInfo.now_money || 0 }}</div>
          </div>
          <div v-else>
            <div
              class="payItem acea-row row-middle"
              :class="active === 'zh' ? 'on' : ''"
              @click="payItem('zh')"
            >
              <div class="name acea-row row-center-wrapper">
                <div
                  class="iconfont icon-icon-test"
                  :class="active === 'zh' ? 'bounceIn' : ''"
                ></div>
                组合支付
              </div>
              <div class="tip">点券支付 <span style='color:red; font-size:0.3rem'>{{userInfo.now_money}}</span>&nbsp; &nbsp;微信支付 <span style='color:red;font-size:0.3rem'>{{ weixin_price(orderPrice.pay_price - userInfo.now_money)}}</span></div>
            </div>
            <div
              class="tip kydq"
              :style="{ color: '#999', 'margin-top': '10px' }"
            >
              可用点券：{{ userInfo.now_money || 0 }}
            </div>
          </div>

          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="offlinePayStatus === 1 && deduction === false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="wrapper" v-else>
        <div class="item">
          <div>支付方式</div>
          <div class="list">
            之前注释
              <div
                 class="payItem acea-row row-middle"
                 :class="active === 'weixin' ? 'on' : ''"
                 @click="payItem('weixin')"
                 v-show="!isWeixin"
               >

                 <div class="name acea-row row-center-wrapper">
                   <div
                     class="iconfont icon-weixin2"
                     :class="active === 'weixin' ? 'bounceIn' : ''"
                   ></div>
                   微信支付
                 </div>
                 <div class="tip">微信快捷支付</div>
               </div>

          <router-link :to="'/user/bindcoupon'" class="binding" >
               <div class="payItem acea-row row-middle">
                    <div class="name acea-row row-center-wrapper">
                      绑定点券
                    </div>
                    <div class="tip">点击绑定点券</div>
                </div>
          </router-link>
          </div>
        </div>
    </div> -->
    <!-- <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.total_price !== undefined"
      >
        <div>商品总价：</div>
        <div class="money">{{ orderPrice.total_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.pay_postage > 0"
      >
        <div>运费：</div>
        <div class="money">{{ orderPrice.pay_postage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-show="false"
        v-if="orderPrice.coupon_price > 0"
      >
        <div>优惠券抵扣：</div>
        <div class="money"></div>
        <div
          class="money"
          v-if="orderPrice.coupon_price >= orderPrice.total_price"
        >
          -{{ orderPrice.total_price }}
        </div>
        <div class="money" v-else>-{{ orderPrice.coupon_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price > 0"
      >
        <div>积分抵扣：</div>
        <div class="money">-{{ orderPrice.deduction_price }}</div>
      </div>
    </div> -->
    <div style="height:1.2rem"></div>

    <div
      style="color:#f44545;background-color:#ffe6e6;text-align:center;margin:0 auto;padding:0.15rem;bottom:1rem;position:fixed;width:100%"
      v-if='donotDeliverGoods()'>
      {{ donotTitle }}
    </div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="font-color-red">{{ orderPrice.pay_price }}</span>
        <!-- <span class="font-color-red" v-if="userInfo.now_money >= orderPrice.pay_price">0</span>
        <span class="font-color-red" v-else>{{orderPrice.pay_price - userInfo.now_money }}</span>-->
      </div>

      <div v-if='donotDeliverGoods()'>
        <div class="settlement" style="background-color:#aaa;">立即结算</div>
      </div>
      <div v-else-if="this.isCannot_p">
        <div class="settlement" style="background-color:#aaa;" @click="cannotPFn">立即结算</div>
      </div>
      <div v-else-if="this.unableToSettle">
        <div class="settlement" style="background-color:#aaa;">立即结算</div>
      </div>
      <div v-else>
        <div class="settlement" @click="createOrder">立即结算</div>
      </div>


    </div>
    <CouponListWindow v-on:couponchange="changecoupon($event)" v-model="showCoupon" :price="orderPrice.total_price"
      :checked="usableCoupon.id" @checked="changeCoupon"></CouponListWindow>
    <AddressWindow @checked="changeAddress" @redirect="addressRedirect" v-model="showAddress" :checked="addressInfo.id"
      ref="mychild"></AddressWindow>
  </div>
</template>
<script>
import { getUser, getMenuUser, getLogout, getCouponsUser } from "@api/user";
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { roundFun } from "@utils/movie.js";
import {
  postOrderConfirm,
  postOrderComputed,
  createOrder,
  getOrderCoupon
} from "@api/order";
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { Icon, Dialog } from "vant";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow,
    Icon
  },
  props: {},
  data: function () {
    return {
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      // active: _isWeixin ? "weixin" : "yue",
      active: "zh",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      donotTitle: null,
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: { coupon_title: "不使用优惠券", id: 0 },
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      num1: 0,
      num2: 0,
      timePrice: null,
      endTime: [],
      gqmes: "",
      userInfo: {},
      couponsList: [],
      donotTitleList: [
        // {type: 1, title: "该商品在该地区暂不支持销售，非常抱歉！"},
        { type: 2, title: "您选择的区域暂不提供发货，望您理解，请选择其他收货地址进行下单。" }
      ],
      notRegions: [
        { province: "台湾", type: 2 },
        { province: "香港特别行政区", type: 2 },
        { province: "澳门特别行政区", type: 2, city: [] },
        { province: "西藏自治区", type: 2, city: [] },
        { province: "新疆维吾尔自治区", type: 2, city: [] },
        // {province: "广东省", type: 2,city: [
        //     {city:"佛山市",district: [{district:"南海区"}]},
        //     {city:"广州市",district: [{district:"荔湾区"}, {district: "越秀区"}]},
        //     {city:"深圳市",district: [{district:"龙岗区"}]}
        // ]},
        // {province: "辽宁省",type: 2,city: [
        //     {city:"营口市",district: [{district:"鲅鱼圈区"}]},]},
        // {province: "安徽省",type: 2,city: [
        //     {city:"六安市"}]}, 
        { province: "宁夏回族自治区", type: 2 },
        { province: "青海省", type: 2 },
        { province: "海南省", type: 2 },
        {
          province: "内蒙古自治区", type: 2, city: [
            { city: "锡林郭勒盟", district: [{ district: "二连浩特市" }] },
            { city: "阿拉善盟", district: [{ district: "额济纳旗" }] },
            { city: "呼伦贝尔市", district: [{ district: "满洲里市" }] }
          ]
        },
        // {province: "甘肃省",type: 2,city: [
        //   {city:"酒泉市", district: [{district:"肃北蒙古族自治县"}]}
        // ]},
        // {province: "河北省",type: 2,city: [
        //   {city:"廊坊市", district: [{district:"大厂回族自治县"}]}
        // ]},
        // {province: "贵州省",type: 2,city: [
        //   {city:"遵义市", district: [{district:"仁怀市"}]}
        // ]},
        // {province: "黑龙江省",type: 2,city: [
        //   {city:"黑河市"}
        // ]},
        // {province: "辽宁省",type: 2,city: [
        //   {city:"大连市"}
        // ]},
        // {province: "上海市",type: 2,city: [
        //   {city:"上海市", district: [{district:"青浦区"},{district:"嘉定区"}]}
        // ]},
        // {province: "河南省",type: 2,city: [
        //   {city:"周口市", district: [{district:"扶沟县"}]}
        // ]},
      ],
      is_product_virtual: null,
      cannot_purchase_goods: [ // 不能购买商品、门票，只能用于购买电影的点券
        { min: 80026683, max: 80027063 },
        // 测试↓
        { min: 80027183, max: 80027184 }
      ],
      isCannot_p: false,
      prompt: "",//冷鲜发货提醒
      //
      unableToSettle: false,
      xuankuaphone: '',//充值账号
      chargeAccountList: []//非实物数据判断
    };
  },
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) this.getCartInfo();
      console.log(n);
    }
  },
  mounted: function () {
    // console.log(this.active);
    var that = this;
    this.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;

    getCouponsUser(0).then(res => {
      // console.log(res.data);
      that.couponsList = res.data;
      this.isQujian();
    });

  },
  methods: {
    donotDeliverGoods: function () {
      let dont = false;
      this.notRegions.forEach((item) => {

        // 省
        if (item.province && (!item.city || (item.city && item.city.length == 0))) {
          if (item.province == this.addressInfo.province) {

            dont = true;
            this.donotTitleList.forEach((dt) => {
              if (item.type == dt.type) {
                this.donotTitle = dt.title;
              }
            })
          }
        }
        // 市 区
        if (item.province && item.city && item.city.length !== 0) {
          if (item.province == this.addressInfo.province) {
            item.city.forEach((val) => {
              //市
              if (val.city == this.addressInfo.city && (!val.district || (val.district && val.district.length == 0))) {
                dont = true;
                this.donotTitleList.forEach((dt) => {
                  if (item.type == dt.type) {
                    this.donotTitle = dt.title;
                  }
                })
              }
              //区
              if (val.city == this.addressInfo.city && (val.district && val.district.length !== 0)) {
                val.district.forEach((ind) => {
                  if (ind.district == this.addressInfo.district) {
                    dont = true;
                    this.donotTitleList.forEach((dt) => {
                      if (item.type == dt.type) {
                        this.donotTitle = dt.title;
                      }
                    })
                  }
                })
              }
            })
          }
        }
      });
      if (!dont) {
        this.donotTitle = "";
      }
      return dont;
    },
    weixin_price: function (n) {
      if (!n) return;
      let val = roundFun(n, 2);
      return val;
    },
    computedPrice() {
      // 这里修改了不使用优惠券
      this.usableCoupon.id = 0;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0
      }).then(res => {
        const data = res.data;
        // return false;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;

          if (data.result.pay_price <= this.userInfo.now_money) {
            this.active = 'yue';
          } else {
            this.active = 'zh';
          }
        }
      });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      this.unableToSettle = false;
      this.userInfo = {};
      this.orderGroupInfo = {
        priceGroup: {}
      };
      this.offlinePayStatus = 2;
      this.usableCoupon = {};
      this.deduction = true;
      this.orderPrice = {
        pay_price: "计算中"
      };

      postOrderConfirm(cartIds)
        .then(res => {
          this.chargeAccountList = res.data.chargeAccountList//非实物
          this.userInfo = res.data.userInfo
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.is_product_virtual = res.data.cartInfo[0].productInfo.is_product_virtual;
          if (res.data.prompt && res.data.prompt != '') {
            this.$dialog.alert({
              mes: res.data.prompt
            })
          }
          this.computedPrice();
          // console.log(res.data.cartInfo,res.data.cartInfo[0].productInfo.is_product_virtual,"pp");
        })
        .catch((err) => {
          let time = 1000;
          if (err.data.status == 400) {
            this.unableToSettle = true;
            time = 5000;
          }
          this.$dialog.error(err.msg, {}, time).then(() => {
            if (err.data.status == 400) {
              this.$router.go(-1);
            }
          });
        });
    },
    isQujian: function () {
      let isT = false;
      for (let t = 0; t < this.couponsList.length; t++) {
        let card = this.couponsList[t].coupon_title;
        // console.log(card,"card");
        for (let i = 0; i < this.cannot_purchase_goods.length; i++) {
          if (card >= this.cannot_purchase_goods[i].min && card <= this.cannot_purchase_goods[i].max) {
            if (card != 80026760 && card != 80026695 && card != 80027047 && card != 80026958 && card != 80026957) {
              this.isCannot_p = true;
              isT = true;
              break;
            }
          }
        }
        if (isT) {
          break;
        }
      }
      if (this.isCannot_p) {
        this.cannotPFn();
      }
    },
    cannotPFn() {
      this.$dialog.error("此券仅限观影使用！");
    },
    addressTap: function () {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function () {
      this.showCoupon = true;
    },
    changeCoupon: function (coupon) {
      // console.log(this.usableCoupon);
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function (index) {
      // console.log(index);
      this.active = index;
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();

    },
    createOrder() {
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      if (!this.addressInfo.id && this.chargeAccountList == []) {
        return this.$dialog.toast({ mes: "请选择收货地址" });
      }
      if (this.changeAccountList && !this.xuankuaphone) {
        return this.$dialog.toast({ mes: '请输入待充值账号' })
      }

      // 这里做的判断 -- 过不过期
      // function formatDate(now) {
      //   var year = now.getFullYear();
      //   var month = now.getMonth() + 1;
      //   var date = now.getDate();
      //   return year + "/" + month + "/" + date;
      // }
      // this.timePrice = formatDate(new Date());

      // getOrderCoupon(this.orderPrice.pay_price).then(res => {
      //   this.endTime = res.data;
      //   console.log(this.endTime[0].end_time);
      //   console.log(this.timePrice);
      //   // 这里要改为>
      //   if (this.endTime[0].end_time > this.timePrice) {
      //     //console.log("已经过了使用期限")
      //     //alert('已经过了使用期限')
      //     this.$dialog.error("点券已失效，请先充值或激活");
      //     setTimeout(() => {
      //       this.$router.push("/user/account");
      //     }, 1500);
      //     return false;
      //   }
      // });

      // if(this.active == "zh"){
      //   this.$dialog.toast({ mes: "暂未开通，敬请期待" });
      // }

      // setTimeout(()=>{
      //   this.$router.push('/')
      // },2000)

      this.$dialog.confirm({
        mes: "确认支付?",
        opts: () => {
          this.$dialog.loading.open("生成订单中");

          /*if (this.orderPrice.pay_price <= this.userInfo.now_money) {
            this.active = "yue";
          } else if (this.orderPrice.pay_price > this.userInfo.now_money) {
            this.active = "weixin";
          }*/
          let querys = this.$route.query.festivalName || null;
          let phone = this.xuankuaphone.replace(/\s/g, '')
          createOrder(this.orderGroupInfo.orderKey, {
            addressId: this.addressInfo.id,
            useIntegral: this.useIntegral ? 1 : 0,
            couponId: this.usableCoupon.id || 0,
            payType: this.active,
            pinkId: this.pinkId,
            seckill_id: this.orderGroupInfo.seckill_id,
            combinationId: this.orderGroupInfo.combination_id,
            bargainId: this.orderGroupInfo.bargain_id,
            from: this.from,
            mark: this.mark || "",
            is_product_virtual: this.is_product_virtual,
            festival_type: querys,
            chargeAccount: phone,
            goodsId: this.chargeAccountList.goodsId,
          })
            .then(res => {
              this.$dialog.loading.close();
              const data = res.data;
              switch (data.status) {
                case "ORDER_EXIST":
                case "EXTEND_ORDER":
                case "PAY_DEFICIENCY":
                case "PAY_ERROR":
                  this.$dialog.toast({ mes: res.msg });
                  if (this.$route.query.festivalName) {
                    this.$router.replace({
                      path: "/festivalUser",
                      query: { festivalName: this.$route.query.festivalName }
                    });
                  } else {
                    this.$router.replace({
                      path: "/user"
                    });
                  }
                  break;
                case "SUCCESS":
                  this.$dialog.success(res.msg);
                  if (this.$route.query.festivalName) {
                    this.$router.replace({
                      path: "/festivalUser",
                      query: { festivalName: this.$route.query.festivalName }
                    });
                  } else {
                    this.$router.replace({
                      path: "/user"
                    });
                  }
                  break;
                case "WECHAT_H5_PAY":
                  if (this.$route.query.festivalName) {
                    this.$router.replace({
                      path: "/festivalUser",
                      query: { festivalName: this.$route.query.festivalName }
                    });
                  } else {
                    this.$router.replace({
                      path: "/user"
                    });
                  }
                  setTimeout(() => {
                    location.href = data.result.jsConfig.mweb_url;
                  }, 100);
                  break;
                case "WECHAT_PAY":
                  pay(data.result.jsConfig).finally(() => {
                    if (this.$route.query.festivalName) {
                      this.$router.replace({
                        path: "/festivalUser",
                        query: { festivalName: this.$route.query.festivalName }
                      });
                    } else {
                      this.$router.replace({
                        path: "/user"
                      });
                    }
                  });
              }
            })
            .catch(err => {
              // console.log(err);
              this.$dialog.loading.close();
              this.$dialog.error(err.msg || "创建订单失败");
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.title_nav {
  display: flex;
  width: 100%;
  /* background: #fff; */
  height: 0.7rem;
  padding-left: 0.2rem;
  padding-top: 0.15rem;
  background: white;
}

.nav_address {
  width: 80%;
  text-align: center;
  margin-left: 0.4rem;
}

.refundlist {
  width: 90%;
  background: white;
  margin-left: 0.4rem;
  margin-top: 0.3rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  padding-bottom: 0.1rem;
  padding-top: 0.1rem;
  display: flex;
  justify-content: space-between;
  text-align: center;
}

.refundlists {
  width: 90%;
  background: white;
  margin-left: 0.4rem;
  margin-top: 0.3rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  padding-bottom: 0.1rem;
  padding-top: 0.1rem;
  justify-content: space-between;
}

.refundlists .item {
  width: 100%;
  /* display: flex; */
  padding: 0.4rem 0.4rem;
}

.refundlists input {
  margin-left: 0rem;
  margin-top: 0.1rem;
  width: 80%;
  height: 0.7rem;
  font-size: 130%;
  font-weight: 300;
  padding-bottom: 0.05rem;
  border-bottom: 0.01rem solid #ccc;
}

.userText {
  padding: 0.1rem 0.4rem;
  display: flex;
}

.userDefault {
  width: .45rem;
  height: .3rem;
  background: red;
  font-size: 0.2rem;
  text-align: center;
  line-height: 0.3rem;
  margin-top: 0.05rem;
  margin-right: 0.2rem;
  color: white;
}

.userAddress {
  padding: 0rem 0.1rem 0.1rem 0.1rem;
}

.routerArrow {
  padding-top: .35rem;
}

.detalis_box {
  width: 90%;
  background: white;
  margin-left: 0.4rem;
  margin-top: 0.2rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

.quantity {
  padding: 0.3rem;
  font-size: 0.3rem;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #242424;
}

.quantit {
  display: flex;
  margin-left: 0.3rem;
}

.quantit img {
  width: 1rem;
  height: 1rem;
}

.quantiy {
  width: 100%;
  margin-left: 0.2rem;
  text-align: left;
}

.quantiy .size {
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #242424;
  width: 100%;
  font-size: 0.25rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.quan {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2rem;
}

.tity {
  color: #ee453e !important;
  display: flex !important;
  width: 21% !important;
}

.tity img {
  width: 0.35rem;
  height: 0.35rem;
}

.Summary {
  width: 100%;
  text-align: right;
  padding: .4rem .3rem;
  font-size: .3rem;
}

.Expressfreight {
  display: flex;
  justify-content: space-between;
  padding: .2rem .3rem;
  font-size: .3rem;
}

.prompttext {
  padding-top: 0.05rem;
  font-size: 0.25rem;
  color: #ff4800;
}
</style>
